import { useState, useEffect } from 'react'

const useZoomLevel = () => {
    const getZoom = () => window.devicePixelRatio || 1

    const [baseRatio] = useState(getZoom())
    const [zoomMultiplier, setZoomMultiplier] = useState(1)

    useEffect(() => {
        const updateZoom = () => {
            const current = getZoom()
            setZoomMultiplier(current / baseRatio)
        }

        window.addEventListener('resize', updateZoom)
        return () => window.removeEventListener('resize', updateZoom)
    }, [baseRatio])

    return zoomMultiplier
}

export default useZoomLevel
